module.exports = __webpack_public_path__ + "assets/webgl/rainbow-ring.e1f7acfe.png";